const ADULT_HOSTS = ["onlyfans.com", "fansly.com", "justfor.fans"];

export const DEFAULT_EXTERNAL_LINKS = [
  { id: "default-twitch", label: "twitch tv", url: "https://www.twitch.tv/xaelserpent", network: "twitch", enabled: true, order: 0 },
  { id: "default-kick", label: "kick.com", url: "https://www.kick.com/xaelserpent", network: "kick", enabled: true, order: 10 },
  { id: "default-facebook", label: "facebook", url: "https://www.facebook.com/xaelserpent", network: "facebook", enabled: true, order: 20 },
  { id: "default-youtube", label: "youtube", url: "https://www.youtube.com/xaelserpent", network: "youtube", enabled: true, order: 30 },
  { id: "default-x", label: "x", url: "https://www.x.com/xaelserpent", network: "x", enabled: true, order: 40 },
  { id: "default-discord", label: "discord: arctic cafe", url: "https://discord.gg/gmDZR2RtPD", network: "discord", enabled: true, order: 50 },
  { id: "default-buymeacoffee", label: "buy me a coffee", url: "https://buymeacoffee.com/xaelserpent", network: "buymeacoffee", enabled: true, order: 60 },
  { id: "default-bitcoin", label: "bitcoin", url: "https://mempool.space/address/1Xaya5XhGqX7d7pjtcXCgPUz8jsjhd3t1", network: "bitcoin", enabled: true, order: 70 },
];

export function externalLinksOrDefault(links) {
  return Array.isArray(links) && links.length ? links : DEFAULT_EXTERNAL_LINKS;
}

export function isAdultLink(url) {
  try {
    const hostname = new URL(url).hostname.toLowerCase().replace(/^www\./, "");
    return ADULT_HOSTS.some((host) => hostname === host || hostname.endsWith(`.${host}`));
  } catch {
    return false;
  }
}
